var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Chromecast = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.tag.getEstimatedTime //this.tag.currentTime
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.tag.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    try {
      if (this.player.getStreamingProtocol) {
        var protocol = this.player.getStreamingProtocol()
        for (var c = 0; c < protocol.getStreamCount(); c++) {
          var streamInfo = protocol.getStreamInfo(c)
          if (streamInfo.mimeType.indexOf('video/') === 0) {
            var videoLevel = protocol.getQualityLevel(c)
            if (streamInfo.bitrates && streamInfo.bitrates[videoLevel]) {
              return streamInfo.bitrates[videoLevel]
            }
          }
        }
      }
      return null // No video stream available
    } catch (err) {
      return null // Stream info not available yet, do nothing
    }
  },

  /** Override to return rendition */
  getRendition: function () {
    var bitrate = this.getBitrate()
    return bitrate > 0 ? Util.buildRenditionString(bitrate) : null
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (!this.tag.currentSrc.startsWith("blob:")) {
      return this.tag.currentSrc
    } else if (this.player) {
      return this.player.getHost().url
    } else {
      return "unknown"
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (cast && cast.player && cast.player.api && cast.player.api.VERSION) {
      return "Chromecast " + cast.player.api.VERSION
    } else {
      return "Chromecast"
    }
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Chromecast"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    this.tag = document.getElementsByTagName('video')[0]

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false, 1200)

    // Register listeners
    this.references = []
    this.references['loadstart'] = this.playListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['seeking'] = this.seekingListener.bind(this)
    this.references['abort'] = this.endedListener.bind(this)
    this.references['ended'] = this.endedListener.bind(this)

    for (var key in this.references) {
      this.tag.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.tag. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.tag && this.references) {
      if (typeof this.tag.removeEventListener === "function") {
        for (var key in this.references) {
          this.tag.removeEventListener(key, this.references[key])
        }
      }
      this.references = []
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) { // ?
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e)
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function (e) {
    this.fireBufferBegin()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  }
})

module.exports = youbora.adapters.Chromecast



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 28
// module chunks = 0